module.exports = __webpack_public_path__ + "assets/tutorial_mission_01.5c598ea3.svg";